export default {
  getHdList: process.env.VUE_APP_API_PREFIX + "/hd/hd/list",
  getHdTasks: process.env.VUE_APP_API_PREFIX + "/hd/hd/tasks",
  getHasGet: process.env.VUE_APP_API_PREFIX + "/hd/hd/stat_click",
  apply: process.env.VUE_APP_API_PREFIX + "/hd/hd/apply",
  getPassport: process.env.VUE_APP_API_PREFIX + "/api-passport/user/info/base",
  getPolyvInfo: process.env.VUE_APP_API_PREFIX + "/ielts-app/polyv/video", //获取保利卫视视频
  getSellerInfo: process.env.VUE_APP_API_PREFIX + "/hd/apply/seller-code",
};
